const sidebarNav = (sidebarNav: HTMLElement) => {
    let to: ReturnType<typeof setTimeout> | number = 0;
    const cntWrapperClass = 'sub-cnt';
    const maxLevels = 8;
    const unit = 'px';
    const contents = sidebarNav.getElementsByClassName(cntWrapperClass);

    const getSettetMaxHeight = (item: HTMLElement) => {
        const actualMax = item.style.getPropertyValue('--max-height');
        return Number(actualMax.replace(unit, ''));
    };

    const setMinHeights = () => {
        Array.from(contents).forEach(setMinHeight);
    };

    const setMinHeight = (item: HTMLElement) => {
        item.style.setProperty('--max-height', (item.firstElementChild as HTMLElement).offsetHeight + unit);
    };

    const setMinHeightWithChild = (item: HTMLElement, childHeight: number) => {
        const actualMax = getSettetMaxHeight(item);
        item.style.setProperty('--max-height', actualMax + childHeight + unit);
    };

    const handleSecondLvlChange: EventListenerOrEventListenerObject = ({
        currentTarget
    }: InputEvent & { currentTarget: HTMLInputElement }) => {
        const { checked } = currentTarget;
        const parentWrp = findParentSubCntDiv(currentTarget);
        const subWrp: HTMLElement = currentTarget.parentElement?.querySelector(`.${cntWrapperClass}`)!;
        const childHeight = getSettetMaxHeight(subWrp);
        setMinHeightWithChild(parentWrp, childHeight * (checked ? 1 : -1));
    };

    const setEventListener = () => {
        Array.from(document.getElementsByClassName('sidebar-nav-toggle-2')).forEach((el: HTMLInputElement) => {
            el.addEventListener('change', handleSecondLvlChange);
        });
    };

    const findParentSubCntDiv = (el: HTMLElement): HTMLElement => {
        let current: HTMLElement | null = el;
        let level = 0;
        while (current && level < maxLevels) {
            if (current.tagName === 'DIV' && current.classList.contains(cntWrapperClass)) {
                return current as HTMLElement;
            }
            current = current.parentElement;
            level++;
        }
        throw new Error(`No parent for sidenav found within ${maxLevels} levels.`);
    };

    window.addEventListener('resize', () => {
        clearTimeout(to);
        to = setTimeout(setMinHeights, 200);
    });

    setMinHeights();
    setEventListener();
};

export default sidebarNav;